{
  "id": "hera",
  "pantheon": "greeks",
  "name": {
    "pt-BR": "Hera",
    "en": "Hera"
  },
  "icon": "gods/hera",
  "portrait": "gods/hera-portrait",
  "age": "mythic",
  "freeUnitsOnAgeUp": {
    "medusa": 1
  },
  "unlocks": ["medusa", "face-of-the-gorgon", "monstrous-rage", "argive-patronage"],
  "powers": ["lightning-storm"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "MythicAgeHera: CreateUnit Medusa at a Temple (one free myth unit), god power LightningStorm (cooldown 240 s); enables the listed unit and techs."
  }
}
